"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingView;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function LoadingView() {
  var [value, setValue] = (0, _react.useState)(0);
  var [subTitle, setSubTitle] = (0, _react.useState)('');
  var [counter, setCounter] = (0, _react.useState)(0);
  var PROGRESS_BAR_GROWTH_RATE = 0.5;
  var theme = (0, _core.useTheme)();
  var isDesktop = (0, _core.useMediaQuery)(theme.breakpoints.up('sm'));
  var classes = (0, _styles.default)();
  (0, _react.useEffect)(() => {
    var interval = setInterval(() => {
      if (counter <= 2) {
        setValue(40);
      }
      if (counter > 2 && counter % 2 === 0 && value <= 90) {
        setValue(prevValue => prevValue + PROGRESS_BAR_GROWTH_RATE / 100 * 100);
      }
      if (counter === 10) {
        setSubTitle('Seu livro esta sendo carregado');
      }
      if (counter === 40) {
        setSubTitle('Nós carregamos o livro por completo para permitir a leitura offline. Aguarde, livros grandes como esse podem demorar mais que o esperado.');
      }
      if (counter === 120) {
        setSubTitle('O carregamento está demorando mais que o esperado. Verifique sua conexão ou aguarde mais um pouco.');
      }
      setCounter(prevCounter => prevCounter + 2);
    }, 2000);
    return () => clearInterval(interval);
  }, [counter, value]);
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "h2",
    className: classes.title
  }, "Carregando..."), /*#__PURE__*/_react.default.createElement(_saraivaUi.ProgressBar, {
    color: "secondary",
    small: true,
    value: value,
    className: classes.progressBar,
    size: isDesktop ? 'md' : 'sm'
  }), subTitle && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    component: "p",
    className: classes.subTitle
  }, subTitle));
}